import styled, { css } from 'styled-components'

export const Container = styled.footer`
  position: relative;
  width: 100%;
  padding: 1rem;

  display: grid;
  grid-auto-rows: minmax(170px, min-content);
  gap: 2rem;

  border-radius: 8px;
  background: ${({ theme }) => theme.zds.colors.neutral1000};
`

export const FooterSection = styled.section`
  position: relative;
  width: 100%;
  padding: 1rem;
  background: ${props => props.theme.colors.colorf3f5f9};
  border: 1px solid ${props => props.theme.colors.color122d52};
  border-radius: ${({ theme }) => theme.zds.border.radius100};
`

export const Title = styled.h3`
  color: ${props => props.theme.colors.color2d3139};
  font-family: 'Inter';
  font-size: 10px;
  font-style: normal;
  font-weight: 600;
  line-height: 15px;

  margin-bottom: 0.5rem;
`

export const ListDescription = styled.ul`
  list-style-position: inside;
  margin: 0;
  padding: 0;
  list-style-type: disc;
`

const DefaultText = css`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 12px;
  color: ${props => props.theme.colors.color545e6c};
`

export const Text = styled.p`
  ${DefaultText}
`

export const ListItem = styled.li`
  ${DefaultText}
`
